<app-scroll-view class="scroll-view">
  <form class="form" [formGroup]="formGroup" (ngSubmit)="onSubmit($event)">
    <div class="fields-container">
      <div *ngIf="isTitleVisible" class="field-set">
  <label label>{{ translationService.getCurrentLanguage()['map-title'] }}</label>

        <app-input-box
          formControlName="titleMap"
          [maxLength]="textMaxLengthDefault"
          [showErrorEnabled]="false"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-input-box>
      </div>

      <div *ngIf="isAuthorVisible" class="field-set">
        <label label>Autor</label>

        <app-input-box
          formControlName="author"
          [maxLength]="20"
          [showErrorEnabled]="false"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-input-box>
      </div>

      <div class="field-set">
  <label label>{{ translationService.getCurrentLanguage()['format'] }}*</label>

        <app-select-box
          formControlName="typeFile"
          [items]="typeFileList"
          [displayExpr]="typeFileSelectDisplayExpr"
          valueExpr="value"
          [showErrorEnabled]="false"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-select-box>
      </div>

      <div class="field-set">
  <label label>{{ translationService.getCurrentLanguage()['page-size'] }}</label>

        <app-select-box
          formControlName="paperSizeDimension"
          [items]="paperSizeDimensionList"
          displayExpr="value"
          valueExpr="value"
          [showErrorEnabled]="false"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-select-box>
      </div>

      <div class="field-set">
  <label label>{{ translationService.getCurrentLanguage()['orientation'] }}</label>

        <app-select-box
          formControlName="layoutOrientation"
          [items]="layoutOrientationList"
          displayExpr="label"
          valueExpr="value"
          [showClearButton]="false"
          [showErrorEnabled]="false"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-select-box>
      </div>

      <div class="field-set" *ngIf="isLegendVisible">
        <app-check-box
          class="checkbox"
          formControlName="includesCaption"
          [label]="translationService.getCurrentLanguage()['include-legend']"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-check-box>
      </div>
    </div>

    <div class="actions-bottom">
      <div class="btn-item" [appBlockModalDrag]="!(isMobileModeObservable | async)">
        <app-button
          type="submit"
          buttonType="primary"
          styleType="contained"
          [text]="translationService.getCurrentLanguage()['print']"
          width="10rem"
          [disabled]="isBtnSubmitDisabled"
        ></app-button>
      </div>
    </div>
  </form>
</app-scroll-view>
